module.exports = __webpack_public_path__ + "img/Frame People Tablet.48b033bc.webp";